import { ChatService, ApiResponse, SendMessageRequest, SendMessageResponse } from '../types';
import { Message, Chat, ChatListResponse } from '../../model';
import { BaseService } from '../base-service';

export class ChatServiceReal extends BaseService implements ChatService {
  constructor() {
    super('ChatService');
  }

  async sendMessage(request: SendMessageRequest): Promise<ApiResponse<SendMessageResponse>> {
    this.log('sendMessage', request);

    return this.makeRequest<SendMessageResponse>(`/chats/${request.companionId}/messages`, {
      method: 'POST',
      body: JSON.stringify({ content: request.content }),
    });
  }

  async getChatHistory(companionId: string): Promise<ApiResponse<Message[]>> {
    this.log('getChatHistory', { companionId });

    return this.makeRequest<Message[]>(`/chats/${companionId}/messages`);
  }

  async getChats(userId?: string): Promise<ApiResponse<ChatListResponse>> {
    this.log('getConversations', { userId });

    return this.makeRequest<ChatListResponse>('/chats');
  }

  async getOrCreateChat(companionId: string): Promise<ApiResponse<Chat>> {
    this.log('getOrCreateChat', { companionId });

    // First try to get existing chat
    const existingChat = await this.makeRequest<Chat>(`/chats/${companionId}`);
    if (existingChat.success) {
      return existingChat;
    }

    // If not found, create new chat
    return this.makeRequest<Chat>('/chats', {
      method: 'POST',
      body: JSON.stringify({ companion_id: companionId }),
    });
  }

  async resetChat(companionId: string): Promise<ApiResponse<{ message: string }>> {
    this.log('resetChat', { companionId });

    return this.makeRequest<{ message: string }>(`/chats/${companionId}/messages`, {
      method: 'DELETE',
    });
  }
}
